import { Grid } from "@material-ui/core";
import GraphHeader from "features/landing/components/WorkorderDashboard/GraphHeader/GraphHeader";
import { useEffect, useMemo, useState } from 'react';
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { theme } from "styles/theme";

const UsersPerClient = ({ activeUsers, inActiveUsers, clients }) => {
    activeUsers = activeUsers || [];
    inActiveUsers = inActiveUsers || [];

    const [chartValue, setChartValue] = useState([]);

    const chartData = useMemo(() => {
        if (!clients || (!activeUsers && !inActiveUsers)) return [];
        const activeUsersArray = activeUsers.filter(user => !!user?.accessClient?.length);
        const inactiveUsersArray = inActiveUsers.filter(user => !!user?.accessClient?.length);
        const clientAccounts = clients?.flatMap(c => c.clientAccounts);

        return clientAccounts.map(acc => {
            let activeCount = 0, inactiveCount = 0;
            activeUsersArray.forEach(user => {
                const usersFound = user.accessClient.filter(x => x.id === acc.id);
                if (usersFound.length > 0) {
                    activeCount += 1;
                }
            });
            inactiveUsersArray.forEach(user => {
                const usersFound = user.accessClient.filter(x => x.id === acc.id);
                if (usersFound.length > 0) {
                    inactiveCount += 1;
                }
            });
            if (activeCount === 0 && inactiveCount === 0) return null;
            return {
                ...clientAccounts,
                activeQuantity: activeCount,
                inactiveQuantity: inactiveCount
            };
        });
    }, [clients, activeUsers, inActiveUsers]);

    useEffect(() => {
        if (chartData) {
            setChartValue(chartData?.filter(x => x != null));
        }
    }, [chartData]);

    return (
        <Grid style={{ height: 350 }}>
            <Grid item>
                <GraphHeader
                    title={'Users Per Client'}
                />
            </Grid>
            <Grid item style={{ height: 320, marginTop: "1rem" }}>
                <ResponsiveContainer width="90%" height="100%">
                    <BarChart
                        data={chartValue}
                    >
                        <YAxis
                            type="number"
                            axisLine={false}
                            tickLine={false}
                        />
                        <XAxis
                            type="category"
                            axisLine={false}
                            interval={~~(chartValue?.length / 40)}
                            dataKey="name"
                            tickLine={false}
                            tick={{
                                color: theme.palette.primary.main,
                                fontSize: '0.8em',
                                fontWeight: '500',
                                dx: -4,
                            }}
                            angle={-90} // Adjust angle to rotate labels
                            textAnchor="end" // Aligns the text properly when rotated
                            height={100}
                        />
                        <Tooltip />

                        <Legend
                            wrapperStyle={{ top: -12, left: 175 }}
                            iconType="circle"
                            iconSize={10}
                        />

                        <Bar dataKey="activeQuantity" fill="#9bdc8a" name="Active Users" />
                        <Bar dataKey="inactiveQuantity" fill="#e8a48e" name="Inactive Users" />

                    </BarChart>
                </ResponsiveContainer>
            </Grid>
        </Grid>
    );
};

export default UsersPerClient;
